<template>
  <div class="ledger-entries-table">
    <CDataTable
      :items="entries"
      :fields="tableFields"
      :bordered="true"
      :striped="true"
      class="custom-table cus custom-table--clean mb-0"
    >
      <template #stakeholder="{item}">
        <td class="text-nowrap">
          <span v-if="item.stakeholder && item.stakeholder.legal_name">
            {{ item.stakeholder.legal_name }}
          </span>
          <span v-else>{{ getStakeholderLabel(getStakeholderType(item)) }}</span>
        </td>
      </template>

      <template #entry_type="{item}">
        <td>
          <CBadge :color="getStakeholderColor(getStakeholderType(item))" class="entry-type-badge">
            {{ getEntryTypeLabel(item.entry_type) }}
          </CBadge>
        </td>
      </template>

      <template #amount="{item}">
        <td :class="getAmountClass(item.amount)" class="text-right text-nowrap">
          {{ item.amount|currency(item.currency) }}
        </td>
      </template>

      <template #amount_eur="{item}">
        <td :class="getAmountClass(item.amount_eur)" class="text-right text-nowrap">
          <template v-if="item.currency && item.currency !== 'EUR' && item.amount_eur != null">
            {{ item.amount_eur|currency('EUR') }}
            <div v-if="item.exchange_rate" class="text-muted small font-weight-normal">
              <translate translate-context="accounting.ledger">Rate</translate>:
              {{ formatExchangeRate(item.exchange_rate) }}
            </div>
          </template>
          <span v-else class="text-muted">-</span>
        </td>
      </template>
    </CDataTable>

    <div v-if="entries.length === 0" class="text-center py-4">
      <CIcon name="cipXCircle" size="xl" class="mb-2"/>
      <p class="mb-0">
        <translate translate-context="accounting.ledger">No ledger entries found</translate>
      </p>
    </div>
  </div>
</template>

<script>
import {
  STAKEHOLDER_TYPE_LABELS,
  ENTRY_TYPE_LABELS,
  getStakeholderColor as resolveStakeholderColor
} from '../constants'

export default {
  name: 'LedgerEntriesTableBody',
  props: {
    entries: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    tableFields() {
      const fields = [
        {
          key: 'entry_type',
          label: this.$pgettext('accounting.ledger', 'Type'),
          _style: 'width: 180px;'
        },
        {key: 'stakeholder', label: this.$pgettext('accounting.ledger', 'Stakeholder')},
        {
          key: 'amount',
          label: this.$pgettext('accounting.ledger', 'Amount'),
          _classes: 'text-right',
          _style: 'width: 160px;'
        },
      ]

      if (this.hasNonEurCurrency) {
        fields.push({
          key: 'amount_eur',
          label: this.$pgettext('accounting.ledger', 'Amount (EUR)'),
          _classes: 'text-right',
          _style: 'width: 180px;'
        })
      }

      return fields
    },

    hasNonEurCurrency() {
      return this.entries.some(e => e.currency && e.currency !== 'EUR')
    },
  },
  methods: {
    getStakeholderType(entry) {
      return entry.stakeholder ? entry.stakeholder.stakeholder_type : null
    },
    getStakeholderLabel(type) {
      return STAKEHOLDER_TYPE_LABELS[type] || type || '-'
    },
    getStakeholderColor(type) {
      return resolveStakeholderColor(type)
    },
    getEntryTypeLabel(type) {
      const label = ENTRY_TYPE_LABELS[type] || type || ''
      return String(label).toUpperCase()
    },
    getAmountClass(amount) {
      const num = parseFloat(amount)
      if (num > 0) return 'success'
      if (num < 0) return 'warning'
      return ''
    },
    formatExchangeRate(rate) {
      const num = parseFloat(rate)
      if (!num || isNaN(num)) return ''
      return num.toFixed(4)
    },
  }
}
</script>

<style scoped>
.entry-type-badge {
  color: #fff !important;
  font-weight: 600;
  padding: 4px 8px;
}
</style>
